var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"center-box"},[_c('p',[_vm._v(" 会员中心 > "),_c('span',{staticClass:"act"},[_vm._v(_vm._s(_vm.activeName))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }